import { render } from "./Wfh.vue?vue&type=template&id=0bb4ac32"
import script from "./Wfh.vue?vue&type=script&lang=js"
export * from "./Wfh.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__